import { max } from "rxjs";
import { ConfigurationOptionsPriceFormationEnum } from "src/app/Enums/ConfigurationOptionsPriceFormationEnum";

export function onlyNumbers(value: string) {
    if (!value) {
        value = "";
    }

    return value.replace(/\D/g, '');
}

export function blockLetterOnDocumentVerifiers(event: KeyboardEvent, currentValue: string | null): void {
    if (event.ctrlKey || event.metaKey || event.altKey) return; //Não bloquear atalhos (ex.: Ctrl+A, Ctrl+C, Ctrl+V)
    if (event.key.length !== 1) return;
    const raw = (currentValue ?? '').replace(/[.\-/]/g, '').toUpperCase();
    const hasLetter = /[A-Z]/.test(raw);
    if ((hasLetter || raw.length >= 11) && raw.length >= 12 && /[A-Za-z]/.test(event.key)) {
        event.preventDefault();
    }
}

export function maskDocument(texto: string): string {
    const raw = texto.trim().replace(/\s+/g, '').replace(/[.\-/]/g, '').toUpperCase();
    const hasLetter = /[A-Z]/.test(raw);
    if (!hasLetter && raw.length <= 11) {
        return maskCPF(raw);
    } else {
        return maskCNPJ(raw);
    }
}

export function maskCNPJ(texto: string): string {
    // Preserva letras A-Z nas 12 primeiras posições; remove apenas separadores e espaços (ex.: colado de outro lugar)
    const raw = texto.trim().replace(/\s+/g, '').replace(/[.\-/]/g, '').toUpperCase().substring(0, 14);
    const n = raw.length;
    if (n <= 2) return raw;
    if (n <= 5) return `${raw.substring(0,2)}.${raw.substring(2)}`;
    if (n <= 8) return `${raw.substring(0,2)}.${raw.substring(2,5)}.${raw.substring(5)}`;
    if (n <= 12) return `${raw.substring(0,2)}.${raw.substring(2,5)}.${raw.substring(5,8)}/${raw.substring(8)}`;
    return `${raw.substring(0,2)}.${raw.substring(2,5)}.${raw.substring(5,8)}/${raw.substring(8,12)}-${raw.substring(12)}`;
}

export function maskCPF(texto: string): string {
    texto = onlyNumbers(texto); //Remove tudo o que não é dígito
    texto = texto.replace(/^(\d{3})(\d)/, '$1.$2'); //Coloca ponto entre o segundo e o terceiro dígitos
    texto = texto.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3'); //Coloca ponto entre o quinto e o sexto dígitos
    return texto.replace(/(\d{3})(\d)/, '$1-$2'); //Coloca um hífen depois do bloco de quatro dígitos
}

export function maskDoc(texto: string, formato: string, regex: RegExp) {
    texto = onlyNumbers(texto);
    texto = texto.replace(regex, formato);
    return texto;
}

export function maskCEP(texto: string): string {
    texto = onlyNumbers(texto); //Remove tudo o que não é dígito
    texto = texto.replace(/^(\d{2})(\d)/, '$1.$2'); //Coloca ponto entre o segundo e o terceiro dígitos
    return texto.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2-$3'); //Coloca ponto entre o quinto e o sexto dígitos
}

export function maskTelephone(texto: string): string {
    texto = onlyNumbers(texto);
    if (texto.length >= 11) {
        texto = texto.replace(/(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }
    else {
        texto = texto.replace(/(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }
    return texto;
}

export function maskParaguaiTelephone(texto: string): string {
    texto = onlyNumbers(texto);
    if (texto.length >= 9) {
        texto = texto.replace(/(\d{3})(\d{3})(\d{3})$/, '($1) $2-$3');
    } else {
        texto = texto.replace(/(\d{2})(\d{3})(\d{3})$/, '($1) $2-$3');
    }
    return texto;
}

export function withoutCaractereSpecial(event: any) {
    const pattern = /^[0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;
    if (!pattern.test(String.fromCharCode(event.charCode))) {
        event.preventDefault();
    }
}

export function maskBrasilMoney(valor: string): string {
    if (valor) {
        valor = valor.replace(',', '');
        valor = valor + '';
        valor = valor.replace(/[\D]+/g, '');
        valor = valor + '';

        if (valor.length <= 2) {
            valor = valor.replace(/([0-9]{1})$/g, ",$1")
        }
        else if (valor.length > 2 && valor.length < 6) {
            valor = valor.replace(/([0-9]{2})$/g, ",$1");
        }
        else {
            valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        }
    }
    return valor;
}

export function casaDecimalMoedaBrasil(valor: string, casaDecimal: number = 2): string {
    return moneyBrasilToFloat(valor).toLocaleString("pt-BR", { minimumFractionDigits: casaDecimal, currency: 'BRL' });
}


export function moneyBrasilToFloat(valor: string): number {
    if(!valor)
      return 0;
    return Number.parseFloat(valor.replace('R$', '').replace(' ', '').replace('.', '').replace(',', '.'));
}
export function percentToFloat(valor: string): number {
    if(!valor)
        return 0;
    return Number.parseFloat(valor.replace('%', '').replace(' ', '').replace('.', '').replace(',', '.'));
}

export function formatPercentValue(input: string): string {
  if (!input) return '';

  // Remove tudo que não é número, vírgula ou ponto
  input = input.replace(/[^\d.,]/g, '');

  // Normaliza vírgula para ponto
  const normalized = input.replace(',', '.');

  const num = parseFloat(normalized);
  if (isNaN(num)) return '';
  

  // Detecta quantas casas decimais o usuário digitou
  const decimalMatch = normalized.match(/\.(\d{1,})$/);
  const userDecimals = decimalMatch ? decimalMatch[1].length : 0;

  // Garante mínimo de 2, máximo de 4, e dentro do intervalo permitido
  const minDecimals = Math.max(2, Math.min(userDecimals, 20));
  const maxDecimals = Math.max(minDecimals, Math.min(userDecimals || 4, 20));

  const formatted = num.toLocaleString('pt-BR', {
    style: 'decimal',
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  });

  return `${formatted}%`;
}


const DIGIT_EXPRESSION: RegExp = /^\d$/;

export function isDigit(character: string): boolean {
    return DIGIT_EXPRESSION.test(character);
};

export function formatNumberToEnUsPatternWithDecimal(value: number): string {
    if (!isNaN(value))
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 3 })
            .format(value);
    return ""
}

export function isNullOrWhitespace(input: string | null | undefined): boolean {
    return !input || input.trim().length === 0;
}

export function DecimalToMoneyStringHelper(value: any,  minimumFractionDigits: number =2, maximumFractionDigits: number=2): string {
    let numberValue: number;
    // Se for um número já processado (do cálculo), usa diretamente
    if (typeof value === 'number') {
      numberValue = value;
    } else {
      // Se for string formatada como moeda, extrai os números e divide por 100
      const onlyNumbers = String(value).replace(/\D/g, "");
      const div=minimumFractionDigits ==4 || maximumFractionDigits ==4 ? 10000 : 100;
      numberValue = (+onlyNumbers / div);
    }
    if(isNaN(numberValue))
        numberValue = 0;

    const formattedValue = numberValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
    });

    return formattedValue;
  }

export function DecimalToPercentStringHelper(value: any, minimumFractionDigits: number = 2, maximumFractionDigits: number = 4): string {
  let numberValue: number;

  // Se for um número já processado (do cálculo), usa diretamente
  if (typeof value === 'number') {
    numberValue = value / 100;
  } else {
    // Se for string, extrai apenas os números
    const onlyNumbers = String(value).replace("%","").replace(/\D/g, "");
    numberValue = (+onlyNumbers / 10000); // 10 -> 0,0010 (4 casas)
  }
  if (isNaN(numberValue))
    numberValue = 0;

  const formattedValue = numberValue.toLocaleString('pt-BR', {
    style: 'currency',
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
    currency: 'BRL',
  });

  return `${formattedValue}`.replace("R$","%").trim();
}

/**
 * Replace all label occurrences for margin/markup according to PriceFormation config.
 * @param label Original label string
 * @param priceFormationValueSet Enum value for PriceFormation (Margin or Markup)
 * @returns Label with correct replacements
 */
export function replaceMarginMarkupLabel(label: string, priceFormationValueSet: number): string {
  if (!label) return '';
  // 1 = Margin, 2 = Markup (conforme ConfigurationOptionsPriceFormationEnum)
  if (priceFormationValueSet === ConfigurationOptionsPriceFormationEnum.Margin) {
    // Sempre exibe "a margem"
    return label.replace(/margem\/markup|o Markup|a Margem/gi, 'a Margem');
  } else {
    // Sempre exibe "o markup"
    return label.replace(/margem\/markup|a Margem|o Markup/gi, 'o Markup');
  }
}

